<template>
  <div id="app">
    <AppHeader />
    
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import AppHeader from '@/components/Layout/AppHeader.vue';
import AppFooter from '@/components/Layout/AppFooter.vue';
</script>

<style lang="scss">
// Reset & Base Styles
* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: $background-base;
  color: $text-primary;
}

#app {
  @apply min-h-screen;
  @apply flex flex-col;
}

.main-content {
  @apply flex-1;
}

// Transitions
.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-base ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// Scrollbar Styling (Webkit)
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: $background-dark;
}

::-webkit-scrollbar-thumb {
  background: $spotify-gray;
  border-radius: $radius-full;
  
  &:hover {
    background: $spotify-light-gray;
  }
}

// Selection
::selection {
  background: $spotify-green;
  color: $spotify-white;
}
</style>